export const Types = {
  GET_ALL_WEIGHTGAINPROJECTION: "weightGainProjection/GET_ALL_WEIGHTGAINPROJECTION",
  GET_ALL_WEIGHTGAINPROJECTION_SUCCESS:
    "weightGainProjection/GET_ALL_WEIGHTGAINPROJECTION_SUCCESS",
  GET_ALL_WEIGHTGAINPROJECTION_ERROR:
    "weightGainProjection/GET_ALL_WEIGHTGAINPROJECTION_ERROR",
  GET_WEIGHTGAINPROJECTION: "weightGainProjection/GET_WEIGHTGAINPROJECTION",
  GET_WEIGHTGAINPROJECTION_SUCCESS:
    "weightGainProjection/GET_WEIGHTGAINPROJECTION_SUCCESS",
  GET_WEIGHTGAINPROJECTION_ERROR:
    "weightGainProjection/GET_WEIGHTGAINPROJECTION_ERROR",
  SAVE_WEIGHTGAINPROJECTION: "weightGainProjection/SAVE_WEIGHTGAINPROJECTION",
  SAVE_WEIGHTGAINPROJECTION_SUCCESS:
    "weightGainProjection/SAVE_WEIGHTGAINPROJECTION_SUCCESS",
  SAVE_WEIGHTGAINPROJECTION_ERROR:
    "weightGainProjection/SAVE_WEIGHTGAINPROJECTION_ERROR",
  INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION:
    "weightGainProjection/INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION",
  INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION_SUCCESS:
    "weightGainProjection/INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION_SUCCESS",
  INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION_ERROR:
    "weightGainProjection/INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION_ERROR",
  SHOW_DRAWER_WEIGHTGAINPROJECTION:
    "weightGainProjection/SHOW_DRAWER_WEIGHTGAINPROJECTION",
  HIDE_DRAWER_WEIGHTGAINPROJECTION:
    "weightGainProjection/HIDE_DRAWER_WEIGHTGAINPROJECTION",
};

export const Creators = {
  indexWeightGainProjection: (
    groupId,
    farmId,
    page = 0,
    sorter = {},
    filters = "",
    withoutPagination = false,
    ids,
    signal = null
  ) => ({
    type: Types.GET_ALL_WEIGHTGAINPROJECTION,
    payload: {
      groupId,
      farmId,
      page,
      sorter,
      filters,
      withoutPagination,
      ids,
      signal,
    },
  }),
  indexWeightGainProjectionSuccess: (data) => ({
    type: Types.GET_ALL_WEIGHTGAINPROJECTION_SUCCESS,
    payload: {
      data,
    },
  }),
  indexWeightGainProjectionError: (error) => ({
    type: Types.GET_ALL_WEIGHTGAINPROJECTION_ERROR,
    payload: {
      error,
    },
  }),
  showWeightGainProjection: (groupId, farmId, id) => ({
    type: Types.GET_WEIGHTGAINPROJECTION,
    payload: {
      groupId,
      farmId,
      id,
    },
  }),
  showWeightGainProjectionSuccess: (data) => ({
    type: Types.GET_WEIGHTGAINPROJECTION_SUCCESS,
    payload: {
      data,
    },
  }),
  showWeightGainProjectionError: (error) => ({
    type: Types.GET_WEIGHTGAINPROJECTION_ERROR,
    payload: {
      error,
    },
  }),
  saveWeightGainProjection: (
    groupId,
    farmId,
    id = null,
    weightGainProjection,
    saveOptions
  ) => ({
    type: Types.SAVE_WEIGHTGAINPROJECTION,
    payload: {
      groupId,
      farmId,
      id,
      weightGainProjection,
      saveOptions,
    },
  }),
  saveWeightGainProjectionSuccess: (data, saveOptions) => ({
    type: Types.SAVE_WEIGHTGAINPROJECTION_SUCCESS,
    payload: { data, saveOptions },
  }),
  saveWeightGainProjectionError: (error) => ({
    type: Types.SAVE_WEIGHTGAINPROJECTION_ERROR,
    payload: { error },
  }),
  inactivateOrActivateWeightGainProjection: (
    groupId,
    farmId,
    id,
    weightGainProjection,
    action
  ) => ({
    type: Types.INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION,
    payload: {
      groupId,
      farmId,
      id,
      weightGainProjection,
      action,
    },
  }),
  inactivateOrActivateWeightGainProjectionSuccess: () => ({
    type: Types.INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION_SUCCESS,
    payload: {},
  }),
  inactivateOrActivateWeightGainProjectionError: (error) => ({
    type: Types.INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION_ERROR,
    payload: { error },
  }),
  showDrawerWeightGainProjection: (data) => ({
    type: Types.SHOW_DRAWER_WEIGHTGAINPROJECTION,
    payload: {
      data,
    },
  }),
  hideDrawerWeightGainProjection: () => ({
    type: Types.HIDE_DRAWER_WEIGHTGAINPROJECTION,
    payload: {},
  }),
};

const INITIAL_STATE = {
  isLoading: false,
  data: [],
  weightGainProjectionData: null,
  drawerVisible: false,
  error: {},
};

export default function weightGainProjection(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_ALL_WEIGHTGAINPROJECTION:
      return { ...state, isLoading: true };
    case Types.GET_ALL_WEIGHTGAINPROJECTION_SUCCESS:
      return { ...state, isLoading: false, data: action.payload.data };
    case Types.GET_ALL_WEIGHTGAINPROJECTION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case Types.GET_WEIGHTGAINPROJECTION:
      return { ...state, isLoading: true };
    case Types.GET_WEIGHTGAINPROJECTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        weightGainProjectionData: action.payload.data,
      };
    case Types.GET_WEIGHTGAINPROJECTION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case Types.SAVE_WEIGHTGAINPROJECTION:
      return { ...state, isLoading: true };
    case Types.SAVE_WEIGHTGAINPROJECTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        weightGainProjectionData: null,
        drawerVisible: false,
      };
    case Types.SAVE_WEIGHTGAINPROJECTION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case Types.INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION:
      return { ...state, isLoading: true };
    case Types.INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case Types.INACTIVATE_ACTIVATE_WEIGHTGAINPROJECTION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case Types.SHOW_DRAWER_WEIGHTGAINPROJECTION:
      return {
        ...state,
        drawerVisible: true,
        weightGainProjectionData: action.payload.data,
      };
    case Types.HIDE_DRAWER_WEIGHTGAINPROJECTION:
      return { ...state, drawerVisible: false, weightGainProjectionData: null };
    default:
      return state;
  }
}
